import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { UiComponentsModule } from '@app/ui-components/ui-components.module';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { TranslateModule } from '@ngx-translate/core';
import { A11yModule } from '@angular/cdk/a11y';
import { CdkTableModule } from '@angular/cdk/table';
import { ModalmessageComponent } from './modals/modalmessage/modalmessage.component';
import {ModalextensionComponent} from '@app/shared/modals/modalextension/modalextension.component';
import {ModaldevComponent} from '@app/shared/modals/modaldev/modaldev.component';
import { ModalscreenshotComponent } from './modals/modalscreenshot/modalscreenshot.component';
import { ModaluntilComponent } from './modals/modaluntil/modaluntil.component';
import { ModalscreenshotsetupComponent } from './modals/modalscreenshotsetup/modalscreenshotsetup.component';
import { ModalroamingComponent } from './modals/modalroaming/modalroaming.component';
import { AppListComponent } from './components/app-list/app-list.component';
import { ModaltanComponent } from './modals/modaltan/modaltan.component';
import { AppListFilterComponent } from './components/app-list/app-list-filter/app-list-filter.component';
import { ModalgrouprenameComponent } from './modals/modalgrouprename/modalgrouprename.component';
import { ModaldevicenameComponent } from './modals/modaldevicename/modaldevicename.component';
import { TagInputModule } from 'ngx-chips';
import { ModalselfprotectionComponent } from './modals/modalselfprotection/modalselfprotection.component';
import { ModalchangeloginnoticeComponent } from './modals/modalchangeloginnotice/modalchangeloginnotice.component';
import { ModalfilenameComponent } from './modals/modalfilename/modalfilename.component';
import { ModalAppDetailsSuggestionComponent } from './modals/modal-app-details-suggestion/modal-app-details-suggestion.component';
import {ActiondropdownComponent} from '@app/shared/components/actiondropdown/actiondropdown.component';
import {CardDeviceComponent} from '@app/shared/components/card-device/card-device.component';
import {CardPasswordComponent} from '@app/shared/components/card-password/card-password.component';
import {CardRoamingComponent} from '@app/shared/components/card-roaming/card-roaming.component';
import {CardTansComponent} from '@app/shared/components/card-tans/card-tans.component';
import {CardUnlockrequestsComponent} from '@app/shared/components/card-unlockrequests/card-unlockrequests.component';
import { CardNotificationComponent } from './components/card-notification/card-notification.component';
import { ModalwarntimeComponent } from './modals/modalwarntime/modalwarntime.component';
import { ModaldsgvoComponent } from './modals/modaldsgvo/modaldsgvo.component';
import { CardInfoNotificationComponent } from './components/card-info-notification/card-info-notification/card-info-notification.component';
import { CardManipulationComponent } from './components/card-manipulation/card-manipulation.component';
import { TimeboxComponent } from './components/card-device/timebox/timebox.component';
import { ModalapplistComponent } from './modals/modalapplist/modalapplist.component';
import { ModalerrorinterceptorComponent } from './modals/modalerrorinterceptor/modalerrorinterceptor.component';
import { FooterLinksComponent } from './components/footer-links/footer-links.component';

// FontAwesome
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import {
  faPencilAlt as fasPencilAlt,
  faTimes as fasTimes,
  faChevronDown as fasChevronDown,
  faChevronUp as fasChevronUp,
  faMobileAlt as fasMobileAlt,
  faDesktop as fasDesktopAlt,
  faBars as fasBars,
  faEllipsisV as fasEllipsisV,
  faHome as fasHome,
  faGlobe as fasGlobe,
  faMapMarkerAlt as fasMapMarkerAlt,
  faCamera as fasCamera,
  faShieldAlt as fasShieldAlt,
  faEnvelope as fasEnvelope,
  faChartBar as fasChartBar,
  faCog as fasCog,
  faStar as fasStar,
  faExchangeAlt as fasExchangeAlt,
  faPowerOff as fasPowerOff,
  faAngleDoubleRight as fasAngleDoubleRight,
  faExclamationTriangle as fasExclamationTriangle,
  faInfoCircle as fasInfoCircle,
  faUnlock as fasUnlock,
  faLock as fasLock,
  faPlusSquare as fasPlusSquare,
  faSitemap as fasSitemap,
  faSearch as fasSearch,
  faEdit as fasEdit,
  faTrash as fasTrash,
  faWifi as fasWifi,
  faBatteryFull as fasBatteryFull,
  faBatteryHalf as fasBatteryHalf,
  faBatteryQuarter as fasBatteryQuarter,
  faBatteryThreeQuarters as fasBatterThreeQuarters,
  faCheck as fasCheck,
  faPhoneLaptop as fasPhoneLaptop,
  faUser as fasUser,
  faPlus as fasPlus,
  faMinus as fasMinus,
  faQuestionCircle as fasQuestionCircle,
  faTimesCircle as fasTimesCircle,
  faSortUp as fasSortUp,
  faSortDown as fasSortDown,
  faBan as fasBan,
  faCaretDown as fasCaretDown,
  faBullhorn as fasBullhorn,
} from '@fortawesome/pro-solid-svg-icons';
import {
  faClock as farClock,
  faComments as fabComments,
  faBookReader as fabBookReader,
  faBell as farBell,
  faCheckSquare as farCheckSquare,
  faPhoneLaptop as farPhoneLaptop,
  faFolders as faFolders,
  faAlignLeft as faAlignLeft
} from '@fortawesome/pro-regular-svg-icons';
import {
  faWindows as fabWindows
} from '@fortawesome/free-brands-svg-icons';
import { ModaladdentryComponent } from './modals/modaladdentry/modaladdentry.component';
import { TopactivityComponent } from './components/topactivitiy/topactivity.component';
import { BarchartComponent } from './components/barchart/barchart.component';
import { GoogleMapsModule } from '@angular/google-maps';
import {ModalmissingrightComponent} from '@app/shared/modals/modalmissingright/modalmissingright.component';
import {ModalmanualtimesComponent} from '@app/shared/modals/modalmanualtimes/modalmanualtimes.component';
import { ModalprofilesentryComponent } from './modals/modalprofilesentry/modalprofilesentry.component';
import { CardRoamingpieComponent } from './components/card-roamingpie/card-roamingpie.component';
import { ModalsettingsappComponent } from './modals/modalsettingsapp/modalsettingsapp.component';
import { CardExtensionrequestComponent } from './components/card-extensionrequest/card-extensionrequest.component';
import { ChartPieComponent } from './components/chart-pie/chart-pie.component';
import { CardAllowedPlusComponent } from './components/card-allowed-plus/card-allowed-plus.component';
import { ModalspecialappComponent } from './modals/modalspecialapp/modalspecialapp.component';
import { ModalupdatenoticeComponent } from './modals/modalupdatenotice/modalupdatenotice.component';
import { CardDevicewarningComponent } from './components/card-devicewarning/card-devicewarning.component';
import { BatteryiconComponent } from './components/card-device/batteryicon/batteryicon.component';
import { CardFeatureComponent } from './components/card-feature/card-feature.component';
import { CardSoundlimitComponent } from './components/card-soundlimit/card-soundlimit.component';

/**
 * This module contains declarations (components, directives) that are used all over the app.
 * Injectables should not be declared in this module.
 */
@NgModule({
  declarations: [
    ModaldevComponent,
    ModalextensionComponent,
    ModalmanualtimesComponent,
    ModalmessageComponent,
    ModalscreenshotComponent,
    ModaluntilComponent,
    ModalscreenshotsetupComponent,
    ModalroamingComponent,
    AppListComponent,
    ModaltanComponent,
    AppListFilterComponent,
    ModalgrouprenameComponent,
    ModaldevicenameComponent,
    ModalselfprotectionComponent,
    ModalchangeloginnoticeComponent,
    ModalfilenameComponent,
    ModalAppDetailsSuggestionComponent,
    ModalmissingrightComponent,
    ActiondropdownComponent,
    CardDeviceComponent,
    CardPasswordComponent,
    CardRoamingComponent,
    CardTansComponent,
    CardUnlockrequestsComponent,
    CardNotificationComponent,
    ModalwarntimeComponent,
    ModaldsgvoComponent,
    CardInfoNotificationComponent,
    CardManipulationComponent,
    TimeboxComponent,
    ModalapplistComponent,
    ModalerrorinterceptorComponent,
    ModaladdentryComponent,
    TopactivityComponent,
    BarchartComponent,
    FooterLinksComponent,
    ModalprofilesentryComponent,
    CardRoamingpieComponent,
    ModalsettingsappComponent,
    CardExtensionrequestComponent,
    ChartPieComponent,
    CardAllowedPlusComponent,
    ModalspecialappComponent,
    ModalupdatenoticeComponent,
    CardDevicewarningComponent,
    BatteryiconComponent,
    CardFeatureComponent,
    CardSoundlimitComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    TranslateModule,
    FontAwesomeModule,
    TagInputModule,
    // Angular CDK
    CdkTableModule,
    // ngx-bootstrap
    BsDropdownModule,
    TooltipModule,
    PaginationModule,
    // Modules from this project
    UiComponentsModule
  ],
  exports: [
    // Export commonly used modules so that other modules only need to import this SharedModule instead of all the other modules
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    GoogleMapsModule,
    TranslateModule,
    FontAwesomeModule,
    TagInputModule,
    // Angular CDK
    CdkTableModule,
    A11yModule,
    // ngx-bootstrap
    BsDropdownModule,
    TooltipModule,
    PaginationModule,
    ProgressbarModule,
    // Modules from this project
    UiComponentsModule,
    // Components from this module
    AppListComponent,
    ActiondropdownComponent,
    CardDeviceComponent,
    CardPasswordComponent,
    CardRoamingComponent,
    CardTansComponent,
    CardUnlockrequestsComponent,
    CardNotificationComponent,
    CardInfoNotificationComponent,
    CardManipulationComponent,
    TopactivityComponent,
    BarchartComponent,
    FooterLinksComponent,
    CardRoamingpieComponent,
    CardExtensionrequestComponent,
    ChartPieComponent,
    CardAllowedPlusComponent,
    CardDevicewarningComponent,
    CardFeatureComponent,
    CardSoundlimitComponent
  ]
})
export class SharedModule {
  constructor(private library: FaIconLibrary) {
    library.addIcons(
      // fas
      fasPencilAlt,
      fasTimes,
      fasChevronDown,
      fasChevronUp,
      fasMobileAlt,
      fasDesktopAlt,
      fasBars,
      fasEllipsisV,
      fasHome,
      fasGlobe,
      fasMapMarkerAlt,
      fasCamera,
      fasShieldAlt,
      fasEnvelope,
      fasChartBar,
      fasCog,
      fasStar,
      fasExchangeAlt,
      fasPowerOff,
      fasAngleDoubleRight,
      fasExclamationTriangle,
      fasInfoCircle,
      fasUnlock,
      fasLock,
      fasPlusSquare,
      fasSitemap,
      fasSearch,
      fasEdit,
      fasTrash,
      fasWifi,
      fasBatteryFull,
      fasBatteryHalf,
      fasBatteryQuarter,
      fasBatterThreeQuarters,
      fasCheck,
      fasPhoneLaptop,
      fasUser,
      fasPlus,
      fasMinus,
      fasQuestionCircle,
      fasTimesCircle,
      fasSortUp,
      fasSortDown,
      fasBan,
      fasCaretDown,
      fasBullhorn,
      faFolders,
      faAlignLeft,
      // far
      farClock, farBell, farCheckSquare, farPhoneLaptop,
      // fab
      fabWindows,
      fabComments,
      fabBookReader
    );

    TagInputModule.withDefaults({
      tagInput: {
        pasteSplitPattern: /[, ]/
      }
    });
  }
}
